import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, InputGroup } from 'react-bootstrap';
import { SketchPicker } from 'react-color';
import axios from 'axios';
import ntc from 'ntcjs'; // Importing the ntcjs library

const ProductColorsPage = () => {
  const [colors, setColors] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [currentColor, setCurrentColor] = useState({ id: '', color_name: '', color_code: '' });
  const [colorPicker, setColorPicker] = useState('#ffffff');

  useEffect(() => {
    fetchColors();
  }, []);

  const fetchColors = async () => {
    try {
      const response = await axios.get('https://drdprints.com/api/get-productcolors');
      setColors(Array.isArray(response.data.productcolors) ? response.data.productcolors : []);
    } catch (error) {
      console.error('Error fetching colors:', error);
    }
  };

  const handleShowModal = (color) => {
    setCurrentColor(color || { id: '', color_name: '', color_code: '' });
    setColorPicker(color?.color_code || '#ffffff');
    setShowModal(true);
  };

  const handleSaveColor = async () => {
    try {
      const colorData = { ...currentColor, color_code: colorPicker };
      if (colorData.id) {
        await axios.put(`https://drdprints.com/api/update-productcolor/${colorData.id}`, colorData);
      } else {
        await axios.post('https://drdprints.com/api/store-productcolor', colorData);
      }
      fetchColors();
      setShowModal(false);
    } catch (error) {
      console.error('Error saving color:', error);
    }
  };

  const handleDeleteColor = async (id) => {
    try {
      await axios.delete(`https://drdprints.com/api/deleteproductcolor/${id}`);
      fetchColors();
    } catch (error) {
      console.error('Error deleting color:', error);
    }
  };

  const handleColorChange = (color) => {
    const hexColor = color.hex;
    setColorPicker(hexColor);

    // Use ntcjs to get the color name from the hex code
    const colorName = ntc.name(hexColor)[1]; // [1] contains the human-readable color name

    // Update currentColor state with color code and color name
    setCurrentColor({ ...currentColor, color_code: hexColor, color_name: colorName });
  };

  return (
    <div className="container mt-5">
      <h2>Products Colors</h2>
      <Button className="mb-3" onClick={() => handleShowModal()}>Add Color</Button>
      <Table responsive bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Color Name</th>
            <th>Color Code</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {colors.map((color, index) => (
            <tr key={color.id}>
              <td>{index + 1}</td>
              <td>{color.color_name}</td>
              <td>
                <div style={{ backgroundColor: color.color_code, width: '50px', height: '20px' }}></div>
              </td>
              <td>
                <Button variant="warning" className="ms-2" onClick={() => handleShowModal(color)}>Edit</Button>
                <Button variant="danger" className="ms-2"  onClick={() => handleDeleteColor(color.id)}>Delete</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Modal for Adding/Editing Colors */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{currentColor.id ? 'Edit Color' : 'Add Color'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="colorName">
              <Form.Label>Color Name</Form.Label>
              <Form.Control
                type="text"
                value={currentColor.color_name}
                onChange={(e) => setCurrentColor({ ...currentColor, color_name: e.target.value })}
                placeholder="Enter color name"
              />
            </Form.Group>
            <Form.Group controlId="colorCode">
              <Form.Label>Color Code</Form.Label>
              <InputGroup>
                <SketchPicker color={colorPicker} onChangeComplete={handleColorChange} /> {/* Color Picker */}
              </InputGroup>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
          <Button variant="primary" onClick={handleSaveColor}>Save Changes</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ProductColorsPage;
